import { Link } from "react-router-dom";
import { ga4Configured } from "@/lib/ga4";

const COLUMNS = [
  {
    title: "Your kind of break",
    links: [
      { to: "/short-breaks", label: "UK short breaks" },
      { to: "/couples-breaks", label: "Couples breaks" },
      { to: "/weekend-breaks", label: "Weekend breaks" },
      { to: "/experience-breaks", label: "Experience breaks" },
    ],
  },
  {
    title: "Explore",
    links: [
      { to: "/heart-of-england", label: "The Heart of England" },
      { to: "/breaks", label: "All breaks" },
      { to: "/experiences", label: "The experiences" },
      { to: "/compare", label: "How we compare" },
    ],
  },
  {
    title: "The Perfect Break",
    links: [
      { to: "/how-it-works", label: "How it works" },
      { to: "/about", label: "About us" },
      { to: "/reviews", label: "Reviews" },
      { to: "/faqs", label: "FAQs" },
      { to: "/contact", label: "Contact" },
    ],
  },
  {
    title: "Legal",
    links: [
      { to: "/privacy", label: "Privacy notice" },
      { to: "/cookies", label: "Cookies" },
      { to: "/terms", label: "Website terms" },
      { to: "/booking-terms", label: "Booking terms" },
      { to: "/accessibility", label: "Accessibility" },
    ],
  },
];

export function SiteFooter() {
  return (
    <footer className="border-t border-sandline bg-sand-dark" data-testid="site-footer">
      <div className="container-tpb grid gap-10 py-14 sm:grid-cols-2 lg:grid-cols-5">
        <div className="lg:col-span-1">
          <p className="font-serif text-xl font-semibold text-primary">The Perfect Break</p>
          <p className="mt-3 text-sm leading-relaxed text-ink-muted">
            Great-value UK short breaks for adults — hand-picked hotels, memorable experiences, one simple price.
          </p>
        </div>
        {COLUMNS.map((col) => (
          <nav key={col.title} aria-label={col.title}>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">{col.title}</p>
            <ul className="mt-4 space-y-2.5">
              {col.links.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-ink-muted transition-colors duration-300 hover:text-primary" data-testid={`footer-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        ))}
      </div>
      <div className="border-t border-sandline">
        <div className="container-tpb flex flex-col gap-2 py-6 text-xs text-ink-muted sm:flex-row sm:items-center sm:justify-between">
          <p data-testid="footer-operator-note">
            The Perfect Break is operated by the team behind Stay Play Explore. Secure booking is completed through our established Stay Play Explore booking system.
          </p>
          <div className="flex items-center gap-4">
            {ga4Configured() && (
              <button
                type="button"
                onClick={() => window.dispatchEvent(new Event("tpb:reopen-consent"))}
                className="underline-offset-2 transition-colors duration-300 hover:text-primary hover:underline"
                data-testid="cookie-settings-btn"
              >
                Cookie settings
              </button>
            )}
            <p>© {new Date().getFullYear()} The Perfect Break. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
